import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { ReviewWorkspace } from '../components/review/ReviewWorkspace';
import { api } from '../lib/api';
import type { Deliverable } from '../lib/types';

/** Revisão interna de uma peça (dentro do shell da Machine). */
export function PecaRevisaoPage() {
  const { id = '' } = useParams();
  const d = useQuery({ queryKey: ['deliverable', id], queryFn: () => api.get<Deliverable>(`/deliverables/${id}`) });
  return <ReviewWorkspace deliverableId={id} backHref={d.data ? `/projetos/${d.data.projectId}?s=pecas` : '/projetos'} backLabel="← peças" />;
}
